import { SelectMfaFormFooterStyling } from './types';

export const selectMfaFormFooterStyling: SelectMfaFormFooterStyling = {
  confirmBtn: {
    '& .MuiTypography-root': {
      fontWeight: 500,
      lineHeight: { xs: '26px', sm: '18px' },
      verticalTrim: 'cap-height',
      fontSize: '14px',
    },
  },
};
